/**
 * Creating / resolving org tags from the inbox (#646).
 *
 * The inbox has ONE way to turn a tag name into a tag: `POST /api/mail/tags/resolve`.
 * It returns the EXISTING tag when the name is taken (case-insensitively) — untouched,
 * so typing "vip" when the org already has "VIP" yields VIP, never a duplicate, and
 * never recategorises a CRM tag — and creates it with the ADR-002 `Mail` category
 * only when it exists nowhere. Any user who can tag mail may call it; changing a tag
 * (colour, category) stays admin-only on `POST /api/tags/definitions`.
 *
 * Applying tags to mail is `useTagMail` in `useMailState`, which takes the
 * `tag_id` this returns. The rail's "+" refetches the folder model itself
 * (`ConnectedFolderRail`), so this stays a plain function rather than a hook.
 */
import { apiPost } from '../lib/api';

/** → `{ created, tag: { tag_id, tag, color, category } }` for one name. */
export async function ensureMailTag(name, headers) {
    const res = await apiPost('/mail/tags/resolve', { names: [name] }, headers);
    const tag = res?.data?.tags?.[0] || null;
    return { created: Boolean(tag?.created), tag };
}
